import React, { useEffect, useState, useRef } from 'react'
import { Button, Wrapper, TitleWrapper, SubMenu, SubMenuButton } from './index.styled'
import { VscAdd, VscRemove, VscChevronRight, VscChevronUp } from 'react-icons/vsc'
import { FormattedMessage } from 'react-intl';

const MenuSubExpansiveGroupComponent = ({
  icontype = "plus", className = "", clickHandler = () => {}, clickSubmenuHandler = () => {},  
  info: { id, title, buttons, active }, withoutTranslation = false, active2 = null
}) => {

  const [ activeButton, setActiveButton ] = useState(null);
  const [subHeight, setSubHeight ] = useState(0);

  const ref = useRef(null);

  const activeSubmenu = (item) => {
    setActiveButton(item?.id);
    clickSubmenuHandler(item)
  }

  const showSubmenu = () => {
    const allButtons = buttons.map((item, index) => {
      const _class = active2 === null ? (activeButton === item?.id ? 'active' : '') : (active2.collection === item?.id ? 'active': '');
      return <SubMenuButton key={item?.id} className={_class} onClick={() => activeSubmenu(item)} delay={(index * .05) + .1}>{item?.title}</SubMenuButton>
    })
    return allButtons;
  }

  useEffect(() => {
    setActiveButton(null);
    setSubHeight(ref?.current?.clientHeight)
  }, [ active ])


  return (
    <Wrapper height={subHeight} className={className}>
      <Button onClick={() => clickHandler(id)}>
        <TitleWrapper>{withoutTranslation === true ? title : <FormattedMessage id={title} />}</TitleWrapper>
        {buttons !== undefined && icontype === 'plus' && ((active) ? <VscRemove /> : <VscAdd />)}
        {buttons !== undefined && icontype === 'arrow' && ((active) ? <VscChevronUp /> : <VscChevronRight />)}
      </Button>
      {buttons &&
        (
          <SubMenu ref={ref}>
            {active && showSubmenu()}
          </SubMenu>
        )
      }
    </Wrapper>
  )
}


export default MenuSubExpansiveGroupComponent;
